export const NOTIFICATIONS_MAX_DEDUPE_CACHE_SIZE = 50;
export const NOTIFICATIONS_MAX_BELL_ITEMS = 10;

/** Base path for notifications (read endpoints + broadcasting auth). */
export const NOTIFICATIONS_BASE_API = "api/admin/v1/notifications";

/** GET list / hydrate from API */
export const NOTIFICATIONS_FEED_API = `${NOTIFICATIONS_BASE_API}/feed`;

export const NOTIFICATIONS_READ_ALL_API = `${NOTIFICATIONS_BASE_API}/read-all`;
export const NOTIFICATIONS_READ_BY_ID_API = (id: string) =>
  `${NOTIFICATIONS_BASE_API}/${id}/read`;
